import Amplify, { Auth } from 'aws-amplify'

// For local development, these parameters are resolved from the .env file at the root of the project.
// If running the project for the first time locally, please create a .env file at the root of the project and assign the appropriate values to the env vars for the desired environment.  This file will be ignored by git.
// For deployed environments, the parameters are resolved from a json file in an S3 bucket.
export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      region: "us-east-1",
      userPoolId: "us-east-1_eJSRHKkfR",
      userPoolWebClientId: "7boescpsqp6f7p4t8e52gsjamt",
      mandatorySignIn: true,
    }
  })
}

export const AuthConfiguration = Auth.configure();